var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 4,
    fill: "#1F72CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50726 8L4 15.9897H8.19868L8.71919 14.7158H9.90897L10.4295 15.9897H15.0511V15.0174L15.4629 15.9897H17.8535L18.2653 14.9969V15.9897H27.8769L29.0456 14.7489L30.14 15.9897L35.0767 16L31.5584 12.0172L35.0767 8H30.2165L29.0789 9.21788L28.019 8H17.5628L16.6649 10.0622L15.746 8H11.5561V8.93919L11.09 8H7.50726ZM21.8601 9.13456H27.3795L29.0676 11.0117L30.8102 9.13456H32.4983L29.9334 12.016L32.4983 14.8643H30.7336L29.0455 12.9654L27.2941 14.8643H21.8601V9.13456ZM23.2231 11.3682V10.3217V10.3207H26.6671L28.1699 11.9944L26.6005 13.6773H23.2231V12.5348H26.2342V11.3682H23.2231ZM8.31951 9.13456H10.3661L12.6925 14.5524V9.13456H14.9345L16.7314 13.0191L18.3874 9.13456H20.6182V14.8677H19.2608L19.2497 10.3752L17.2707 14.8677H16.0565L14.0665 10.3752V14.8677H11.274L10.7446 13.5824H7.88445L7.35615 14.8666H5.85997L8.31951 9.13456ZM8.37296 12.3942L9.31526 10.1045L10.2565 12.3942H8.37296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.2c6fec24906b9002af484f0d29a64736.svg";
export { ForwardRef as ReactComponent };